import React, {useContext} from 'react';
import {Button, Dialog, SideSheet} from '@bonprix/design-system';
import {useDispatch, useSelector} from 'react-redux';
import {closeFilter, selectFilterStatus} from '../../FilterSlice.jsx';
import {articleOverviewStaticContext} from '../../ArticleOverviewStatic.jsx';
import {yieldToMain} from '../../ArticleOverviewHelper.js';
import SideSheetLoader from './SideSheetLoader.jsx';
import {loadOn, loadOnAccordeon, selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {setFilterAjaxCall} from '../../AjaxCallSlice.jsx';
import {Constants} from '../../view-constants.js';
import {useTrinity} from '../../hooks/use-trinity.js';
import {useChangeFilters} from '../../hooks/use-change-filters.js';

function FilterSideSheet({hits, filterSubmit, children}) {
    const {texts} = useContext(articleOverviewStaticContext);
    const {sendClickBasic} = useTrinity();

    const filterOpened = useSelector(selectFilterStatus).opened;
    const contentLoading = useSelector(selectLoadingbarStatus).status;
    const filterLoading = useSelector(selectFilterLoadingbarStatus).status;

    const dispatch = useDispatch();
    const {resetFilters} = useChangeFilters();

    const dispatchCloseSideSheet = () => {
        dispatch(setFilterAjaxCall(['', false]));
        dispatch(closeFilter());
    };
    const closeSideSheet = () => {
        dispatchCloseSideSheet();
        sendClickBasic('close_filter_sorting', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    const resetFilterClick = () => {
        yieldToMain(() => dispatch(loadOnAccordeon()));
        resetFilters(true);
        sendClickBasic('reset_filter', Constants.FILTER_VIEW_EVENT_VERSION);
    };

    const submitButtonClick = () => {
        yieldToMain(() => {
            dispatch(loadOnAccordeon());
        });
        filterSubmit();
    };

    return (
        <SideSheet isOpen={filterOpened} onClose={closeSideSheet} zIndex={1000}>
            <SideSheet.Title>{texts.filter_title}</SideSheet.Title>
            <SideSheet.Content>
                {children}
                <SideSheetLoader />
            </SideSheet.Content>
            <Dialog.PrimaryButton>
                <Button
                    onClick={submitButtonClick}
                    variant="primary"
                    loading={contentLoading}
                    disabled={filterLoading || hits === 0}
                >
                    {texts.filter_submit} ({hits})
                </Button>
            </Dialog.PrimaryButton>
            <Dialog.SecondaryButton>
                <Button onClick={resetFilterClick} variant="secondary" disabled={filterLoading}>
                    {texts.filter_reset_sidesheet}
                </Button>
            </Dialog.SecondaryButton>
        </SideSheet>
    );
}

export default React.memo(FilterSideSheet);
